<template>
    <div class="drawer-user-balance">
        <v-col
            v-if="userBalanceData.sbbonusid || userBalanceData.bonusid"
            class="py-0 px-2"
            :class="isNormalWallet ? 'green_bg' : 'primary'"
        >
            <v-list color="transparent" class="pa-0">
                <v-list-item class="pa-0">
                    <template>
                        <v-list-item-content>
                            <v-list-item-title
                                class="font-weight-bold white--text pl-2 f14"
                            >
                                <span> Normal Wallet</span>
                            </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-switch
                                v-model="isNormalWallet"
                                :loading="loading"
                                :disabled="isNormalWallet ? true : false"
                                color="white"
                                flat
                                hide-details
                                @change="updateWallet('normal', isNormalWallet)"
                            ></v-switch>
                        </v-list-item-action>
                    </template>
                </v-list-item>
            </v-list>
        </v-col>
        <!-- <v-col class="d-flex pa-2 green_bg">
            <v-list color="transparent" class="pa-0">
                <v-list-item class="pa-0">
                    <v-list-item-content>
                        <v-list-item-title
                            class="font-weight-bold white--text pl-2 f14"
                        >
                            <span> Normal Wallet</span>
                        </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-content>
                        <v-list-item-action>
                            <v-switch
                                v-model="isNormalWallet"
                                :loading="loading"
                                color="white"
                                flat
                                hide-details
                                @change="updateWallet('normal', isSportBonusOn)"
                            ></v-switch>
                        </v-list-item-action>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-col> -->
        <v-list v-if="$auth.loggedIn && userBalanceData.accessToken" dense>
            <v-list-item class="list_border">
                <v-list-item-subtitle class="white--text">
                    Wallet Amount
                    <div class="f8 white--text">(Inclusive bonus)</div>
                </v-list-item-subtitle>
                <v-list-item-title
                    class="font-weight-bold body-1 primary--text"
                >
                    {{ userBalanceData.main_balance | currencyFormat }}
                    <div>&nbsp;</div>
                </v-list-item-title>
            </v-list-item>

            <v-list-item class="list_border">
                <v-list-item-subtitle class="white--text">
                    Net Exposure
                </v-list-item-subtitle>
                <v-list-item-title
                    class="font-weight-bold body-1"
                    :class="domainUrl ? 'primary--text' : 'superNetExpo--text'"
                >
                    <div v-if="netExposureData.main_netExposure">
                        {{
                            (netExposureData.main_netExposure / getMyRate())
                                | currencyFormat
                        }}
                    </div>
                    <div v-if="!netExposureData.main_netExposure">
                        {{ 0 }}
                    </div>
                </v-list-item-title>
            </v-list-item>
            <v-list-item
                v-if="
                    configurationData && configurationData.isNormalBonusWalletOn
                "
                class="list_border"
            >
                <v-list-item-subtitle class="white--text"
                    >Bonus</v-list-item-subtitle
                >
                <v-list-item-title
                    class="font-weight-bold body-1 primary--text"
                >
                    <div v-if="!user.bonus">0</div>
                    <div v-else>{{ user.bonus | currencyFormat(0) }}</div>
                </v-list-item-title>
            </v-list-item>
            <v-list-item class="pb-2">
                <v-list-item-subtitle class="white--text"
                    >Available Withdrawal</v-list-item-subtitle
                >

                <v-list-item-title
                    class="font-weight-bold body-1 primary--text"
                >
                    {{
                        userBalanceData.main_balance > 1000
                            ? userBalanceData.main_balance -
                                  user.bonus * limiter.limiter >
                              0
                                ? userBalanceData.main_balance -
                                  user.bonus * limiter.limiter
                                : 0
                            : 0 | toFloor | currencyFormat(0)
                    }}
                </v-list-item-title>
            </v-list-item>
        </v-list>
        <v-col
            v-if="
                userBalanceData &&
                userBalanceData.accessToken_sp &&
                configurationData &&
                configurationData.isSportBonusWalletOn
            "
            class="py-0 px-2"
            :class="isSportBonusOn ? 'green_bg' : 'primary'"
        >
            <v-list color="transparent" class="pa-0">
                <v-list-item class="pa-0">
                    <template>
                        <v-list-item-content>
                            <v-list-item-title
                                class="font-weight-bold white--text pl-2 f14"
                            >
                                <span> Sports Bonus</span>
                                <v-icon
                                    class="info-icon pa-1"
                                    size="16"
                                    color="white"
                                    @click="openDialog()"
                                    >mdi-information-outline</v-icon
                                >
                                <!-- <span> -->
                                <v-dialog
                                    v-model="dialog1"
                                    max-width="400px"
                                    width="90%"
                                    persistent
                                    light
                                    class="white_bg"
                                >
                                    <!-- </span> -->
                                    <dialog-card>
                                        <template #content>
                                            <v-card flat class="br-10">
                                                <div
                                                    class="primary fw-900 pa-0"
                                                    :class="{
                                                        'px-2': $breakpoint.smAndDown
                                                    }"
                                                >
                                                    <div
                                                        class="text-uppercase text-center white--text py-1"
                                                        :class="[
                                                            $breakpoint.smAndUp
                                                                ? 'f12'
                                                                : 'f10',
                                                            $breakpoint.smAndDown
                                                                ? 'px-3'
                                                                : ''
                                                        ]"
                                                    >
                                                        Sports Bonus Information
                                                        <span
                                                            class="flex-column float-right align-end"
                                                        >
                                                            <v-btn
                                                                x-small
                                                                icon
                                                                fab
                                                                absolute
                                                                class="dialog-top pb-1"
                                                                @click="
                                                                    closeModal1()
                                                                "
                                                            >
                                                                <v-icon
                                                                    color="white"
                                                                    >mdi-close-circle-outline</v-icon
                                                                >
                                                            </v-btn></span
                                                        >
                                                    </div>
                                                </div>
                                                <div
                                                    class="headerText white--text"
                                                >
                                                    <div>
                                                        <v-row
                                                            no-gutters
                                                            align="center"
                                                            justify="center"
                                                            class="text-center center white_bg"
                                                            light
                                                        >
                                                            <v-col
                                                                cols="12"
                                                                class="py-1 d-flex justify-space-between border-bottom"
                                                            >
                                                                <span
                                                                    class="text-left text-uppercase black--text py-1 fw-900"
                                                                    :class="
                                                                        $breakpoint.smAndUp
                                                                            ? 'f12'
                                                                            : 'f10'
                                                                    "
                                                                >
                                                                    Balance:
                                                                </span>
                                                                <span
                                                                    class="text-right text-uppercase green--text py-1 fw-900"
                                                                    :class="
                                                                        $breakpoint.smAndUp
                                                                            ? 'f12'
                                                                            : 'f10'
                                                                    "
                                                                >
                                                                    {{
                                                                        userBalanceData.sp_balance
                                                                            | currencyFormat
                                                                    }}
                                                                    <!-- <v-icon
                                                                        :class="
                                                                            $breakpoint.smAndUp
                                                                                ? 'f16'
                                                                                : 'f12'
                                                                        "
                                                                        size="16"
                                                                        class="font-weight-bold"
                                                                        color="black"
                                                                        >mdi-currency-rupee</v-icon
                                                                    >
                                                                    111 -->
                                                                </span>
                                                            </v-col>
                                                            <v-col
                                                                cols="12"
                                                                class="py-1 d-flex justify-space-between border-bottom"
                                                            >
                                                                <span
                                                                    class="text-left text-uppercase black--text py-1 fw-900"
                                                                    :class="
                                                                        $breakpoint.smAndUp
                                                                            ? 'f12'
                                                                            : 'f10'
                                                                    "
                                                                >
                                                                    Net
                                                                    Exposure:
                                                                </span>
                                                                <span
                                                                    class="text-right text-uppercase red--text py-1 fw-900"
                                                                    :class="
                                                                        $breakpoint.smAndUp
                                                                            ? 'f12'
                                                                            : 'f10'
                                                                    "
                                                                >
                                                                    <div
                                                                        v-if="
                                                                            netExposureData.sp_netExposure
                                                                        "
                                                                    >
                                                                        {{
                                                                            (netExposureData.sp_netExposure /
                                                                                getMyRate())
                                                                                | currencyFormat
                                                                        }}
                                                                    </div>
                                                                    <div
                                                                        v-if="
                                                                            !netExposureData.sp_netExposure
                                                                        "
                                                                    >
                                                                        {{ 0 }}
                                                                    </div>
                                                                </span>
                                                            </v-col>
                                                            <v-col
                                                                cols="12"
                                                                class="py-1 d-flex justify-space-between border-bottom"
                                                            >
                                                                <span
                                                                    class="text-left text-uppercase black--text py-1 fw-900"
                                                                    :class="
                                                                        $breakpoint.smAndUp
                                                                            ? 'f12'
                                                                            : 'f10'
                                                                    "
                                                                >
                                                                    User Sports
                                                                    Bonus:
                                                                </span>
                                                                <span
                                                                    v-if="
                                                                        userBalanceData
                                                                    "
                                                                    class="d-flex justify-content-end ma-top fw-900"
                                                                    :class="
                                                                        $breakpoint.smAndUp
                                                                            ? 'f12'
                                                                            : 'f10'
                                                                    "
                                                                >
                                                                    <v-switch
                                                                        v-model="
                                                                            isSportBonusOn
                                                                        "
                                                                        :loading="
                                                                            loading1
                                                                        "
                                                                        :disabled="
                                                                            userBalanceData.sp_balance >=
                                                                            minBonusAmount
                                                                                ? false
                                                                                : true
                                                                        "
                                                                        color="green"
                                                                        flat
                                                                        hide-details
                                                                        @change="
                                                                            updateWallet(
                                                                                'SportBonus',
                                                                                isSportBonusOn
                                                                            )
                                                                        "
                                                                    ></v-switch>
                                                                </span>
                                                            </v-col>

                                                            <v-col
                                                                cols="12"
                                                                class="py-2 pt-3"
                                                            >
                                                                <v-expansion-panels
                                                                    v-model="
                                                                        panelCheck1
                                                                    "
                                                                >
                                                                    <v-expansion-panel
                                                                        class="main-content grey lighten-3"
                                                                    >
                                                                        <v-expansion-panel-header
                                                                            @click="
                                                                                isWageringInfo(
                                                                                    'SportBonus'
                                                                                )
                                                                            "
                                                                        >
                                                                            <h5
                                                                                class="text-left text-uppercase black--text py-1 fw-900"
                                                                                :class="
                                                                                    $breakpoint.smAndUp
                                                                                        ? 'f12'
                                                                                        : 'f10'
                                                                                "
                                                                            >
                                                                                Sports
                                                                                Bonus
                                                                                Wallet
                                                                            </h5>
                                                                        </v-expansion-panel-header>
                                                                        <v-expansion-panel-content
                                                                            v-if="
                                                                                trnxData &&
                                                                                trnxData[0] &&
                                                                                trnxData[0]
                                                                                    .status ===
                                                                                    'ongoing'
                                                                            "
                                                                            eager
                                                                        >
                                                                            <v-row
                                                                                no-gutters
                                                                                align="center"
                                                                                justify="center"
                                                                                class="text-center center"
                                                                            >
                                                                                <v-col
                                                                                    cols="6"
                                                                                    class="py-1 d-flex justify-space-between"
                                                                                >
                                                                                    <span
                                                                                        class="text-uppercase black--text py-1 fw-700"
                                                                                        :class="
                                                                                            $breakpoint.smAndUp
                                                                                                ? 'f12'
                                                                                                : 'f10'
                                                                                        "
                                                                                    >
                                                                                        Status:
                                                                                        <span
                                                                                            class="text-right text-uppercase py-1 fw-700 success--text"
                                                                                            :class="
                                                                                                $breakpoint.smAndUp
                                                                                                    ? 'f12'
                                                                                                    : 'f10'
                                                                                            "
                                                                                        >
                                                                                            {{
                                                                                                trnxData[0]
                                                                                                    .status
                                                                                            }}
                                                                                        </span>
                                                                                    </span>
                                                                                </v-col>
                                                                                <!-- bonus cancel modal -->
                                                                                <v-col
                                                                                    v-if="
                                                                                        trnxData[0]
                                                                                            .transactionWay ===
                                                                                            'Bonus' &&
                                                                                        (trnxData[0]
                                                                                            .status ===
                                                                                            'pending' ||
                                                                                            trnxData[0]
                                                                                                .status ===
                                                                                                'ongoing' ||
                                                                                            trnxData[0]
                                                                                                .status ===
                                                                                                'queued') &&
                                                                                        trnxData[0]
                                                                                            .turnOverInPercentage !==
                                                                                            100
                                                                                    "
                                                                                    cols="6"
                                                                                    class="text-right"
                                                                                >
                                                                                    <v-dialog
                                                                                        v-model="
                                                                                            CancelBonusDialog[
                                                                                                trnxData[0]
                                                                                                    ._id
                                                                                            ]
                                                                                        "
                                                                                        max-width="450"
                                                                                    >
                                                                                        <template
                                                                                            #activator="{
                                                                                                on
                                                                                            }"
                                                                                        >
                                                                                            <v-btn
                                                                                                v-if="
                                                                                                    version &&
                                                                                                    version.projectCode &&
                                                                                                    version.projectCode !==
                                                                                                        'bd' &&
                                                                                                    trnxData[0]
                                                                                                        .transactionWay ===
                                                                                                        'Bonus'
                                                                                                "
                                                                                                color="error"
                                                                                                x-small
                                                                                                class="cancel-transaction-btn font-8"
                                                                                                v-on="
                                                                                                    on
                                                                                                "
                                                                                            >
                                                                                                <v-tooltip
                                                                                                    bottom
                                                                                                >
                                                                                                    <template
                                                                                                        #activator="{
                                                                                                            on,
                                                                                                            attrs
                                                                                                        }"
                                                                                                    >
                                                                                                        <span
                                                                                                            v-bind="
                                                                                                                attrs
                                                                                                            "
                                                                                                            v-on="
                                                                                                                on
                                                                                                            "
                                                                                                            >cancel
                                                                                                            bonus
                                                                                                        </span>
                                                                                                    </template>
                                                                                                    <span
                                                                                                        >Cancel
                                                                                                        Bonus</span
                                                                                                    >
                                                                                                </v-tooltip>
                                                                                            </v-btn>
                                                                                            <v-btn
                                                                                                v-if="
                                                                                                    trnxData[0]
                                                                                                        .transactionWay !==
                                                                                                    'Bonus'
                                                                                                "
                                                                                                color="error"
                                                                                                x-small
                                                                                                class="mt-2 cancel-transaction-btn font-8"
                                                                                                v-on="
                                                                                                    on
                                                                                                "
                                                                                            >
                                                                                                <v-tooltip
                                                                                                    bottom
                                                                                                >
                                                                                                    <template
                                                                                                        #activator="{
                                                                                                            on,
                                                                                                            attrs
                                                                                                        }"
                                                                                                    >
                                                                                                        <span
                                                                                                            v-if="
                                                                                                                trnxData[0]
                                                                                                                    .transactionWay !==
                                                                                                                'Bonus'
                                                                                                            "
                                                                                                            v-bind="
                                                                                                                attrs
                                                                                                            "
                                                                                                            v-on="
                                                                                                                on
                                                                                                            "
                                                                                                            >cancel</span
                                                                                                        >
                                                                                                    </template>
                                                                                                    <span
                                                                                                        v-if="
                                                                                                            trnxData[0]
                                                                                                                .transactionWay !==
                                                                                                            'Bonus'
                                                                                                        "
                                                                                                        >Cancel
                                                                                                        Transaction</span
                                                                                                    >
                                                                                                </v-tooltip>
                                                                                            </v-btn>
                                                                                        </template>
                                                                                        <v-card
                                                                                            class="card-rounded"
                                                                                        >
                                                                                            <v-btn
                                                                                                icon
                                                                                                small
                                                                                                absolute
                                                                                                color="white"
                                                                                                class="position-btn"
                                                                                                @click="
                                                                                                    $set(
                                                                                                        CancelBonusDialog,
                                                                                                        trnxData[0]
                                                                                                            ._id,
                                                                                                        false
                                                                                                    )
                                                                                                "
                                                                                            >
                                                                                                <v-icon
                                                                                                    >mdi-close</v-icon
                                                                                                >
                                                                                            </v-btn>
                                                                                            <v-card-text
                                                                                                class="primary pa-4 body-1"
                                                                                            >
                                                                                                You
                                                                                                are
                                                                                                about
                                                                                                to
                                                                                                cancel
                                                                                                your
                                                                                                bonus.
                                                                                                Are
                                                                                                you
                                                                                                sure
                                                                                                you
                                                                                                want
                                                                                                to
                                                                                                proceed?
                                                                                            </v-card-text>
                                                                                            <div
                                                                                                class="text-center pa-4"
                                                                                            >
                                                                                                <v-btn
                                                                                                    color="success"
                                                                                                    depressed
                                                                                                    :disabled="
                                                                                                        btnDisable
                                                                                                    "
                                                                                                    outlined
                                                                                                    class="mr-2"
                                                                                                    @click="
                                                                                                        changeStatusBonusInstance(
                                                                                                            trnxData[0]
                                                                                                                ._id,
                                                                                                            'SportBonus'
                                                                                                        )
                                                                                                    "
                                                                                                    >Yes</v-btn
                                                                                                >
                                                                                                <v-btn
                                                                                                    color="error"
                                                                                                    depressed
                                                                                                    outlined
                                                                                                    @click="
                                                                                                        $set(
                                                                                                            CancelBonusDialog,
                                                                                                            trnxData[0]
                                                                                                                ._id,
                                                                                                            false
                                                                                                        )
                                                                                                    "
                                                                                                    >No</v-btn
                                                                                                >
                                                                                            </div>
                                                                                        </v-card>
                                                                                    </v-dialog>
                                                                                </v-col>
                                                                                <!-- bonus progress bar -->
                                                                                <v-col
                                                                                    v-if="
                                                                                        trnxData[0]
                                                                                            .transactionWay ===
                                                                                            'Bonus' &&
                                                                                        trnxData[0]
                                                                                            .status ===
                                                                                            'ongoing'
                                                                                    "
                                                                                    cols="12"
                                                                                >
                                                                                    <v-card-subtitle
                                                                                        class="pb-0 pa-0"
                                                                                    >
                                                                                        <v-progress-linear
                                                                                            :value="
                                                                                                trnxData[0]
                                                                                                    .turnOverInPercentage
                                                                                            "
                                                                                            rounded
                                                                                            background-color="grey darken-2"
                                                                                            height="12"
                                                                                        >
                                                                                            <template
                                                                                                #default="{
                                                                                                    value
                                                                                                }"
                                                                                            >
                                                                                                <div
                                                                                                    class="font-weight-bold white--text percentage-font"
                                                                                                >
                                                                                                    {{
                                                                                                        Math.floor(
                                                                                                            value
                                                                                                        )
                                                                                                    }}
                                                                                                    %
                                                                                                </div>
                                                                                            </template>
                                                                                        </v-progress-linear>
                                                                                        <div
                                                                                            class="d-flex justify-space-between caption"
                                                                                        >
                                                                                            <div
                                                                                                class=""
                                                                                            >
                                                                                                {{
                                                                                                    Math.abs(
                                                                                                        trnxData[0]
                                                                                                            .turnOverMinVal
                                                                                                    )
                                                                                                }}
                                                                                            </div>
                                                                                            <div>
                                                                                                {{
                                                                                                    Math.abs(
                                                                                                        trnxData[0]
                                                                                                            .turnOverMaxVal
                                                                                                    )
                                                                                                }}
                                                                                            </div>
                                                                                        </div>
                                                                                    </v-card-subtitle>
                                                                                </v-col>
                                                                                <v-col
                                                                                    cols="12"
                                                                                    class="py-1 d-flex justify-space-between border-bottom"
                                                                                >
                                                                                    <span
                                                                                        class="text-uppercase black--text py-1 fw-700"
                                                                                        :class="
                                                                                            $breakpoint.smAndUp
                                                                                                ? 'f12'
                                                                                                : 'f10'
                                                                                        "
                                                                                    >
                                                                                        Bonus
                                                                                        Amount:
                                                                                    </span>
                                                                                    <span
                                                                                        class="text-right text-uppercase black--text py-1 fw-700"
                                                                                        :class="
                                                                                            $breakpoint.smAndUp
                                                                                                ? 'f12'
                                                                                                : 'f10'
                                                                                        "
                                                                                    >
                                                                                        {{
                                                                                            trnxData[0]
                                                                                                .amount
                                                                                                | currencyFormat
                                                                                        }}
                                                                                    </span>
                                                                                </v-col>
                                                                                <v-col
                                                                                    cols="12"
                                                                                    class="py-1 d-flex justify-space-between border-bottom"
                                                                                >
                                                                                    <span
                                                                                        class="text-uppercase black--text py-1 fw-700"
                                                                                        :class="
                                                                                            $breakpoint.smAndUp
                                                                                                ? 'f12'
                                                                                                : 'f10'
                                                                                        "
                                                                                    >
                                                                                        Wagering
                                                                                        Remaining:
                                                                                    </span>
                                                                                    <span
                                                                                        class="text-right text-uppercase black--text py-1 fw-700"
                                                                                        :class="
                                                                                            $breakpoint.smAndUp
                                                                                                ? 'f12'
                                                                                                : 'f10'
                                                                                        "
                                                                                    >
                                                                                        <span
                                                                                            v-if="
                                                                                                trnxData[0]
                                                                                                    .turnOverInPercentage &&
                                                                                                trnxData[0]
                                                                                                    .turnOverInPercentage >=
                                                                                                    100
                                                                                            "
                                                                                        >
                                                                                            0
                                                                                        </span>
                                                                                        <span
                                                                                            v-else
                                                                                        >
                                                                                            {{
                                                                                                trnxData[0]
                                                                                                    .bonusProgress &&
                                                                                                trnxData[0]
                                                                                                    .bonusProgress
                                                                                                    .value &&
                                                                                                trnxData[0]
                                                                                                    .bonusProgress
                                                                                                    .data
                                                                                                    ? trnxData[0]
                                                                                                          .bonusProgress
                                                                                                          .data
                                                                                                          .milestoneAmount -
                                                                                                      trnxData[0]
                                                                                                          .bonusProgress
                                                                                                          .data
                                                                                                          .turnoverAmount
                                                                                                    : 0
                                                                                            }}
                                                                                        </span>
                                                                                    </span>
                                                                                </v-col>

                                                                                <v-col
                                                                                    cols="12"
                                                                                    class="py-1 d-flex justify-space-between border-bottom"
                                                                                >
                                                                                    <span
                                                                                        class="text-uppercase black--text py-1 fw-700"
                                                                                        :class="
                                                                                            $breakpoint.smAndUp
                                                                                                ? 'f12'
                                                                                                : 'f10'
                                                                                        "
                                                                                    >
                                                                                        Bonus
                                                                                        Issued:
                                                                                    </span>
                                                                                    <span
                                                                                        class="text-right text-capitalize black--text py-1 fw-700"
                                                                                        :class="
                                                                                            $breakpoint.smAndUp
                                                                                                ? 'f12'
                                                                                                : 'f10'
                                                                                        "
                                                                                    >
                                                                                        {{
                                                                                            trnxData[0]
                                                                                                .date
                                                                                                ? $moment(
                                                                                                      trnxData[0]
                                                                                                          .date
                                                                                                  ).format(
                                                                                                      "Do-MMM-YY hh:mm a"
                                                                                                  )
                                                                                                : $moment(
                                                                                                      trnxData[0]
                                                                                                          .createdAt
                                                                                                  )
                                                                                                      .add(
                                                                                                          bonusExpireDate,
                                                                                                          "d"
                                                                                                      )
                                                                                                      .format(
                                                                                                          "Do-MMM-YY hh:mm a"
                                                                                                      )
                                                                                        }}
                                                                                    </span>
                                                                                </v-col>
                                                                                <v-col
                                                                                    cols="12"
                                                                                    class="py-1 d-flex justify-space-between"
                                                                                >
                                                                                    <span
                                                                                        class="text-uppercase black--text py-1 fw-700"
                                                                                        :class="
                                                                                            $breakpoint.smAndUp
                                                                                                ? 'f12'
                                                                                                : 'f10'
                                                                                        "
                                                                                    >
                                                                                        Bonus
                                                                                        Expiry:
                                                                                    </span>
                                                                                    <span
                                                                                        class="text-right text-capitalize black--text py-1 fw-700"
                                                                                        :class="
                                                                                            $breakpoint.smAndUp
                                                                                                ? 'f12'
                                                                                                : 'f10'
                                                                                        "
                                                                                    >
                                                                                        {{
                                                                                            trnxData[0]
                                                                                                .expiryDate
                                                                                                ? $moment(
                                                                                                      trnxData[0]
                                                                                                          .expiryDate
                                                                                                  ).format(
                                                                                                      "Do-MMM-YY hh:mm a"
                                                                                                  )
                                                                                                : $moment(
                                                                                                      trnxData[0]
                                                                                                          .createdAt
                                                                                                  )
                                                                                                      .add(
                                                                                                          bonusExpireDate,
                                                                                                          "d"
                                                                                                      )
                                                                                                      .format(
                                                                                                          "Do-MMM-YY hh:mm a"
                                                                                                      )
                                                                                        }}
                                                                                    </span>
                                                                                </v-col>
                                                                            </v-row>
                                                                        </v-expansion-panel-content>
                                                                        <v-expansion-panel-content
                                                                            v-else-if="
                                                                                !trnxData ||
                                                                                (trnxData &&
                                                                                    trnxData.length ==
                                                                                        0)
                                                                            "
                                                                            eager
                                                                        >
                                                                            <v-row
                                                                                no-gutters
                                                                                align="center"
                                                                                justify="center"
                                                                                class="text-center center"
                                                                            >
                                                                                <v-col
                                                                                    cols="12"
                                                                                    class="py-1"
                                                                                >
                                                                                    <span
                                                                                        class="text-capitalize black--text py-1 fw-700"
                                                                                        :class="
                                                                                            $breakpoint.smAndUp
                                                                                                ? 'f12'
                                                                                                : 'f10'
                                                                                        "
                                                                                    >
                                                                                        No
                                                                                        Bonus
                                                                                        Found
                                                                                    </span>
                                                                                </v-col>
                                                                            </v-row>
                                                                        </v-expansion-panel-content>
                                                                    </v-expansion-panel>
                                                                </v-expansion-panels>
                                                            </v-col>
                                                            <v-col
                                                                cols="12 py-3"
                                                            >
                                                                <div
                                                                    class="d-flex justify-end"
                                                                >
                                                                    <!-- <a
                                                                        href="/new-pending-bonus?type=SportBonus"
                                                                        class="link transparent primary--text"
                                                                        >VIEW
                                                                        MORE
                                                                        <v-icon
                                                                            color="primary"
                                                                            class="right-arrow f14"
                                                                            >mdi-arrow-right</v-icon
                                                                        >
                                                                    </a> -->
                                                                    <v-btn
                                                                        :to="'/new-pending-sportbonus?type=SportBonus'"
                                                                        color="primary"
                                                                        class="text-decoration link transparent"
                                                                        text
                                                                    >
                                                                        View
                                                                        More
                                                                        <v-icon
                                                                            color="primary"
                                                                            class="right-arrow f14"
                                                                            >mdi-arrow-right</v-icon
                                                                        >
                                                                    </v-btn>
                                                                </div>
                                                            </v-col>
                                                            <v-col
                                                                cols="12 py-3"
                                                            >
                                                                <div
                                                                    v-if="
                                                                        domainUrl
                                                                    "
                                                                >
                                                                    <a
                                                                        class="text-center text-uppercase blue--text py-3 fw-900"
                                                                        :class="
                                                                            $breakpoint.smAndUp
                                                                                ? 'f14'
                                                                                : 'f12'
                                                                        "
                                                                        @click="
                                                                            termspopup(
                                                                                'terms1'
                                                                            )
                                                                        "
                                                                        >Terms
                                                                        and
                                                                        Conditions</a
                                                                    >
                                                                </div>
                                                                <v-row
                                                                    justify="center"
                                                                >
                                                                    <v-dialog
                                                                        v-model="
                                                                            termsdialog1
                                                                        "
                                                                        scrollable
                                                                        width="400px"
                                                                        light
                                                                    >
                                                                        <v-card
                                                                            height="270px"
                                                                        >
                                                                            <v-card-title
                                                                                class="elevation-2"
                                                                            >
                                                                                <span
                                                                                    class="text-md-h5 text-sm-h5 dialog-title"
                                                                                >
                                                                                    Terms
                                                                                    and
                                                                                    Conditions
                                                                                </span>
                                                                            </v-card-title>
                                                                            <v-card-text
                                                                                v-if="
                                                                                    !termscheck
                                                                                "
                                                                            >
                                                                                <terms-conditions />
                                                                            </v-card-text>

                                                                            <v-card-actions>
                                                                                <v-spacer></v-spacer>
                                                                                <v-btn
                                                                                    color="primary"
                                                                                    class="dialog-btn"
                                                                                    @click="
                                                                                        termsdialog1 = false
                                                                                    "
                                                                                >
                                                                                    close
                                                                                </v-btn>
                                                                            </v-card-actions>
                                                                        </v-card>
                                                                    </v-dialog>
                                                                </v-row>
                                                            </v-col>
                                                        </v-row>
                                                    </div>
                                                </div>
                                            </v-card>
                                        </template>
                                    </dialog-card>
                                </v-dialog>
                            </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action v-if="userBalanceData">
                            <v-switch
                                v-model="isSportBonusOn"
                                :loading="loading"
                                :disabled="
                                    userBalanceData.sp_balance >= minBonusAmount
                                        ? false
                                        : true
                                "
                                color="white"
                                flat
                                hide-details
                                @change="
                                    updateWallet('SportBonus', isSportBonusOn)
                                "
                            ></v-switch>
                        </v-list-item-action>
                    </template>
                </v-list-item>
            </v-list>
        </v-col>
        <v-list
            v-if="
                $auth.loggedIn &&
                userBalanceData &&
                userBalanceData.accessToken_sp &&
                configurationData &&
                configurationData.isSportBonusWalletOn
            "
            dense
        >
            <v-list-item class="list_border">
                <v-list-item-subtitle class="white--text">
                    Sports Bonus
                </v-list-item-subtitle>
                <v-list-item-title
                    class="font-weight-bold body-1 primary--text"
                >
                    {{ userBalanceData.sp_balance | currencyFormat }}
                </v-list-item-title>
            </v-list-item>

            <v-list-item>
                <v-list-item-subtitle class="white--text">
                    Net Exposure
                </v-list-item-subtitle>
                <v-list-item-title
                    class="font-weight-bold body-1"
                    :class="domainUrl ? 'primary--text' : 'superNetExpo--text'"
                >
                    <div v-if="netExposureData.sp_netExposure">
                        {{
                            (netExposureData.sp_netExposure / getMyRate())
                                | currencyFormat
                        }}
                    </div>
                    <div v-if="!netExposureData.sp_netExposure">
                        {{ 0 }}
                    </div>
                </v-list-item-title>
            </v-list-item>
        </v-list>
        <v-col
            v-if="
                userBalanceData &&
                userBalanceData.accessToken_bonus &&
                configurationData &&
                configurationData.isBonusWalletOn
            "
            class="py-0 px-2"
            :class="isBonusOn ? 'green_bg' : 'primary'"
        >
            <v-list color="transparent" class="pa-0">
                <v-list-item class="pa-0">
                    <template>
                        <v-list-item-content>
                            <v-list-item-title
                                class="font-weight-bold white--text pl-2 f14"
                            >
                                <span>Bonus</span>
                                <v-icon
                                    class="info-icon pa-1"
                                    size="16"
                                    color="white"
                                    @click="openDialog2()"
                                    >mdi-information-outline</v-icon
                                >
                                <v-dialog
                                    v-model="dialog2"
                                    max-width="400px"
                                    width="90%"
                                    persistent
                                    light
                                >
                                    <!-- </span> -->
                                    <dialog-card>
                                        <template #content>
                                            <v-card flat class="br-10">
                                                <div
                                                    class="primary fw-900 pa-0"
                                                >
                                                    <div
                                                        class="text-uppercase text-center white--text py-1 f10"
                                                    >
                                                        Bonus Information
                                                        <span
                                                            class="flex-column float-right align-end"
                                                        >
                                                            <v-btn
                                                                x-small
                                                                icon
                                                                fab
                                                                absolute
                                                                class="dialog-top pb-1"
                                                                @click="
                                                                    closeModal2()
                                                                "
                                                            >
                                                                <v-icon
                                                                    color="white"
                                                                    >mdi-close-circle-outline</v-icon
                                                                >
                                                            </v-btn></span
                                                        >
                                                    </div>
                                                </div>
                                                <div
                                                    class="headerText white--text"
                                                >
                                                    <div>
                                                        <v-row
                                                            no-gutters
                                                            align="center"
                                                            justify="center"
                                                            class="text-center center white_bg"
                                                            light
                                                        >
                                                            <v-col
                                                                cols="12"
                                                                class="py-1 d-flex justify-space-between border-bottom"
                                                            >
                                                                <span
                                                                    class="text-left text-uppercase black--text py-1 fw-900"
                                                                    :class="
                                                                        $breakpoint.smAndUp
                                                                            ? 'f12'
                                                                            : 'f10'
                                                                    "
                                                                >
                                                                    Balance:
                                                                </span>
                                                                <span
                                                                    class="text-right text-uppercase green--text py-1 fw-900"
                                                                    :class="
                                                                        $breakpoint.smAndUp
                                                                            ? 'f12'
                                                                            : 'f10'
                                                                    "
                                                                >
                                                                    {{
                                                                        userBalanceData.bonus_balance
                                                                            | currencyFormat
                                                                    }}
                                                                    <!-- <v-icon
                                                                        :class="
                                                                            $breakpoint.smAndUp
                                                                                ? 'f16'
                                                                                : 'f12'
                                                                        "
                                                                        size="16"
                                                                        class="font-weight-bold"
                                                                        color="black"
                                                                        >mdi-currency-rupee</v-icon
                                                                    >
                                                                    111 -->
                                                                </span>
                                                            </v-col>
                                                            <v-col
                                                                cols="12"
                                                                class="py-1 d-flex justify-space-between border-bottom"
                                                            >
                                                                <span
                                                                    class="text-left text-uppercase black--text py-1 fw-900"
                                                                    :class="
                                                                        $breakpoint.smAndUp
                                                                            ? 'f12'
                                                                            : 'f10'
                                                                    "
                                                                >
                                                                    Net
                                                                    Exposure:
                                                                </span>
                                                                <span
                                                                    class="text-right text-uppercase red--text py-1 fw-900"
                                                                    :class="
                                                                        $breakpoint.smAndUp
                                                                            ? 'f12'
                                                                            : 'f10'
                                                                    "
                                                                >
                                                                    <div
                                                                        v-if="
                                                                            netExposureData.bonus_netExposure
                                                                        "
                                                                    >
                                                                        {{
                                                                            (netExposureData.bonus_netExposure /
                                                                                getMyRate())
                                                                                | currencyFormat
                                                                        }}
                                                                    </div>
                                                                    <div
                                                                        v-if="
                                                                            !netExposureData.bonus_netExposure
                                                                        "
                                                                    >
                                                                        {{ 0 }}
                                                                    </div>
                                                                </span>
                                                            </v-col>
                                                            <v-col
                                                                cols="12"
                                                                class="py-1 d-flex justify-space-between border-bottom"
                                                            >
                                                                <span
                                                                    class="text-left text-uppercase black--text py-1 fw-900"
                                                                    :class="
                                                                        $breakpoint.smAndUp
                                                                            ? 'f12'
                                                                            : 'f10'
                                                                    "
                                                                >
                                                                    User Bonus:
                                                                </span>
                                                                <span
                                                                    v-if="
                                                                        userBalanceData
                                                                    "
                                                                    class="d-flex justify-content-end ma-top fw-900"
                                                                    :class="
                                                                        $breakpoint.smAndUp
                                                                            ? 'f12'
                                                                            : 'f10'
                                                                    "
                                                                >
                                                                    <v-switch
                                                                        v-model="
                                                                            isBonusOn
                                                                        "
                                                                        :loading="
                                                                            loading1
                                                                        "
                                                                        :disabled="
                                                                            userBalanceData.bonus_balance >=
                                                                            minBonusAmount
                                                                                ? false
                                                                                : true
                                                                        "
                                                                        color="green"
                                                                        flat
                                                                        hide-details
                                                                        @change="
                                                                            updateWallet(
                                                                                'Bonus',
                                                                                isBonusOn
                                                                            )
                                                                        "
                                                                    ></v-switch>
                                                                </span>
                                                            </v-col>

                                                            <v-col
                                                                cols="12"
                                                                class="py-2 pt-3"
                                                            >
                                                                <v-expansion-panels
                                                                    v-model="
                                                                        panelCheck2
                                                                    "
                                                                >
                                                                    <v-expansion-panel
                                                                        class="main-content grey lighten-3"
                                                                    >
                                                                        <v-expansion-panel-header
                                                                            @click="
                                                                                isWageringInfo(
                                                                                    'Bonus'
                                                                                )
                                                                            "
                                                                        >
                                                                            <h5
                                                                                class="text-left text-uppercase black--text py-1 fw-900"
                                                                                :class="
                                                                                    $breakpoint.smAndUp
                                                                                        ? 'f12'
                                                                                        : 'f10'
                                                                                "
                                                                            >
                                                                                Bonus
                                                                                Wallet
                                                                            </h5>
                                                                        </v-expansion-panel-header>
                                                                        <v-expansion-panel-content
                                                                            v-if="
                                                                                trnxData &&
                                                                                trnxData[0] &&
                                                                                trnxData[0]
                                                                                    .status ===
                                                                                    'ongoing'
                                                                            "
                                                                            eager
                                                                        >
                                                                            <v-row
                                                                                no-gutters
                                                                                align="center"
                                                                                justify="center"
                                                                                class="text-center center"
                                                                            >
                                                                                <v-col
                                                                                    cols="6"
                                                                                    class="py-1 d-flex justify-space-between"
                                                                                >
                                                                                    <span
                                                                                        class="text-uppercase black--text py-1 fw-700"
                                                                                        :class="
                                                                                            $breakpoint.smAndUp
                                                                                                ? 'f12'
                                                                                                : 'f10'
                                                                                        "
                                                                                    >
                                                                                        Status:
                                                                                        <span
                                                                                            class="text-right text-uppercase py-1 fw-700 success--text"
                                                                                            :class="
                                                                                                $breakpoint.smAndUp
                                                                                                    ? 'f12'
                                                                                                    : 'f10'
                                                                                            "
                                                                                        >
                                                                                            {{
                                                                                                trnxData[0]
                                                                                                    .status
                                                                                            }}
                                                                                        </span>
                                                                                    </span>
                                                                                </v-col>
                                                                                <!-- bonus cancel modal -->
                                                                                <v-col
                                                                                    v-if="
                                                                                        trnxData[0]
                                                                                            .transactionWay ===
                                                                                            'Bonus' &&
                                                                                        (trnxData[0]
                                                                                            .status ===
                                                                                            'pending' ||
                                                                                            trnxData[0]
                                                                                                .status ===
                                                                                                'ongoing' ||
                                                                                            trnxData[0]
                                                                                                .status ===
                                                                                                'queued') &&
                                                                                        trnxData[0]
                                                                                            .turnOverInPercentage !==
                                                                                            100
                                                                                    "
                                                                                    cols="6"
                                                                                    class="text-right"
                                                                                >
                                                                                    <v-dialog
                                                                                        v-model="
                                                                                            CancelBonusDialog[
                                                                                                trnxData[0]
                                                                                                    ._id
                                                                                            ]
                                                                                        "
                                                                                        max-width="450"
                                                                                    >
                                                                                        <template
                                                                                            #activator="{
                                                                                                on
                                                                                            }"
                                                                                        >
                                                                                            <v-btn
                                                                                                v-if="
                                                                                                    version &&
                                                                                                    version.projectCode &&
                                                                                                    version.projectCode !==
                                                                                                        'bd' &&
                                                                                                    trnxData[0]
                                                                                                        .transactionWay ===
                                                                                                        'Bonus'
                                                                                                "
                                                                                                color="error"
                                                                                                x-small
                                                                                                class="cancel-transaction-btn font-8"
                                                                                                v-on="
                                                                                                    on
                                                                                                "
                                                                                            >
                                                                                                <v-tooltip
                                                                                                    bottom
                                                                                                >
                                                                                                    <template
                                                                                                        #activator="{
                                                                                                            on,
                                                                                                            attrs
                                                                                                        }"
                                                                                                    >
                                                                                                        <span
                                                                                                            v-bind="
                                                                                                                attrs
                                                                                                            "
                                                                                                            v-on="
                                                                                                                on
                                                                                                            "
                                                                                                            >cancel
                                                                                                            bonus
                                                                                                        </span>
                                                                                                    </template>
                                                                                                    <span
                                                                                                        >Cancel
                                                                                                        Bonus</span
                                                                                                    >
                                                                                                </v-tooltip>
                                                                                            </v-btn>
                                                                                            <v-btn
                                                                                                v-if="
                                                                                                    trnxData[0]
                                                                                                        .transactionWay !==
                                                                                                    'Bonus'
                                                                                                "
                                                                                                color="error"
                                                                                                x-small
                                                                                                class="mt-2 cancel-transaction-btn font-8"
                                                                                                v-on="
                                                                                                    on
                                                                                                "
                                                                                            >
                                                                                                <v-tooltip
                                                                                                    bottom
                                                                                                >
                                                                                                    <template
                                                                                                        #activator="{
                                                                                                            on,
                                                                                                            attrs
                                                                                                        }"
                                                                                                    >
                                                                                                        <span
                                                                                                            v-if="
                                                                                                                trnxData[0]
                                                                                                                    .transactionWay !==
                                                                                                                'Bonus'
                                                                                                            "
                                                                                                            v-bind="
                                                                                                                attrs
                                                                                                            "
                                                                                                            v-on="
                                                                                                                on
                                                                                                            "
                                                                                                            >cancel</span
                                                                                                        >
                                                                                                    </template>
                                                                                                    <span
                                                                                                        v-if="
                                                                                                            trnxData[0]
                                                                                                                .transactionWay !==
                                                                                                            'Bonus'
                                                                                                        "
                                                                                                        >Cancel
                                                                                                        Transaction</span
                                                                                                    >
                                                                                                </v-tooltip>
                                                                                            </v-btn>
                                                                                        </template>
                                                                                        <v-card
                                                                                            class="card-rounded"
                                                                                        >
                                                                                            <v-btn
                                                                                                icon
                                                                                                small
                                                                                                absolute
                                                                                                color="white"
                                                                                                class="position-btn"
                                                                                                @click="
                                                                                                    $set(
                                                                                                        CancelBonusDialog,
                                                                                                        trnxData[0]
                                                                                                            ._id,
                                                                                                        false
                                                                                                    )
                                                                                                "
                                                                                            >
                                                                                                <v-icon
                                                                                                    >mdi-close</v-icon
                                                                                                >
                                                                                            </v-btn>
                                                                                            <v-card-text
                                                                                                class="primary pa-4 body-1"
                                                                                            >
                                                                                                You
                                                                                                are
                                                                                                about
                                                                                                to
                                                                                                cancel
                                                                                                your
                                                                                                bonus.
                                                                                                Are
                                                                                                you
                                                                                                sure
                                                                                                you
                                                                                                want
                                                                                                to
                                                                                                proceed?
                                                                                            </v-card-text>
                                                                                            <div
                                                                                                class="text-center pa-4"
                                                                                            >
                                                                                                <v-btn
                                                                                                    color="success"
                                                                                                    depressed
                                                                                                    :disabled="
                                                                                                        btnDisable
                                                                                                    "
                                                                                                    outlined
                                                                                                    class="mr-2"
                                                                                                    @click="
                                                                                                        changeStatusBonusInstance(
                                                                                                            trnxData[0]
                                                                                                                ._id,
                                                                                                            'Bonus'
                                                                                                        )
                                                                                                    "
                                                                                                    >Yes</v-btn
                                                                                                >
                                                                                                <v-btn
                                                                                                    color="error"
                                                                                                    depressed
                                                                                                    outlined
                                                                                                    @click="
                                                                                                        $set(
                                                                                                            CancelBonusDialog,
                                                                                                            trnxData[0]
                                                                                                                ._id,
                                                                                                            false
                                                                                                        )
                                                                                                    "
                                                                                                    >No</v-btn
                                                                                                >
                                                                                            </div>
                                                                                        </v-card>
                                                                                    </v-dialog>
                                                                                </v-col>
                                                                                <!-- bonus progress bar -->
                                                                                <v-col
                                                                                    v-if="
                                                                                        trnxData[0]
                                                                                            .transactionWay ===
                                                                                            'Bonus' &&
                                                                                        trnxData[0]
                                                                                            .status ===
                                                                                            'ongoing'
                                                                                    "
                                                                                    cols="12"
                                                                                >
                                                                                    <v-card-subtitle
                                                                                        class="pb-0 pa-0"
                                                                                    >
                                                                                        <v-progress-linear
                                                                                            :value="
                                                                                                trnxData[0]
                                                                                                    .turnOverInPercentage
                                                                                            "
                                                                                            rounded
                                                                                            background-color="grey darken-2"
                                                                                            height="12"
                                                                                        >
                                                                                            <template
                                                                                                #default="{
                                                                                                    value
                                                                                                }"
                                                                                            >
                                                                                                <div
                                                                                                    class="font-weight-bold white--text percentage-font"
                                                                                                >
                                                                                                    {{
                                                                                                        Math.floor(
                                                                                                            value
                                                                                                        )
                                                                                                    }}
                                                                                                    %
                                                                                                </div>
                                                                                            </template>
                                                                                        </v-progress-linear>
                                                                                        <div
                                                                                            class="d-flex justify-space-between caption"
                                                                                        >
                                                                                            <div
                                                                                                class=""
                                                                                            >
                                                                                                {{
                                                                                                    Math.abs(
                                                                                                        trnxData[0]
                                                                                                            .turnOverMinVal
                                                                                                    )
                                                                                                }}
                                                                                            </div>
                                                                                            <div>
                                                                                                {{
                                                                                                    Math.abs(
                                                                                                        trnxData[0]
                                                                                                            .turnOverMaxVal
                                                                                                    )
                                                                                                }}
                                                                                            </div>
                                                                                        </div>
                                                                                    </v-card-subtitle>
                                                                                </v-col>
                                                                                <v-col
                                                                                    cols="12"
                                                                                    class="py-1 d-flex justify-space-between border-bottom"
                                                                                >
                                                                                    <span
                                                                                        class="text-uppercase black--text py-1 fw-700"
                                                                                        :class="
                                                                                            $breakpoint.smAndUp
                                                                                                ? 'f12'
                                                                                                : 'f10'
                                                                                        "
                                                                                    >
                                                                                        Bonus
                                                                                        Amount:
                                                                                    </span>
                                                                                    <span
                                                                                        class="text-right text-uppercase black--text py-1 fw-700"
                                                                                        :class="
                                                                                            $breakpoint.smAndUp
                                                                                                ? 'f12'
                                                                                                : 'f10'
                                                                                        "
                                                                                    >
                                                                                        {{
                                                                                            trnxData[0]
                                                                                                .amount
                                                                                                | currencyFormat
                                                                                        }}
                                                                                    </span>
                                                                                </v-col>
                                                                                <v-col
                                                                                    cols="12"
                                                                                    class="py-1 d-flex justify-space-between border-bottom"
                                                                                >
                                                                                    <span
                                                                                        class="text-uppercase black--text py-1 fw-700"
                                                                                        :class="
                                                                                            $breakpoint.smAndUp
                                                                                                ? 'f12'
                                                                                                : 'f10'
                                                                                        "
                                                                                    >
                                                                                        Wagering
                                                                                        Remaining:
                                                                                    </span>
                                                                                    <span
                                                                                        class="text-right text-uppercase black--text py-1 fw-700"
                                                                                        :class="
                                                                                            $breakpoint.smAndUp
                                                                                                ? 'f12'
                                                                                                : 'f10'
                                                                                        "
                                                                                    >
                                                                                        <span
                                                                                            v-if="
                                                                                                trnxData[0]
                                                                                                    .turnOverInPercentage &&
                                                                                                trnxData[0]
                                                                                                    .turnOverInPercentage >=
                                                                                                    100
                                                                                            "
                                                                                        >
                                                                                            0
                                                                                        </span>
                                                                                        <span
                                                                                            v-else
                                                                                        >
                                                                                            {{
                                                                                                trnxData[0]
                                                                                                    .bonusProgress &&
                                                                                                trnxData[0]
                                                                                                    .bonusProgress
                                                                                                    .value &&
                                                                                                trnxData[0]
                                                                                                    .bonusProgress
                                                                                                    .data
                                                                                                    ? trnxData[0]
                                                                                                          .bonusProgress
                                                                                                          .data
                                                                                                          .milestoneAmount -
                                                                                                      trnxData[0]
                                                                                                          .bonusProgress
                                                                                                          .data
                                                                                                          .turnoverAmount
                                                                                                    : 0
                                                                                            }}
                                                                                        </span>
                                                                                    </span>
                                                                                </v-col>

                                                                                <v-col
                                                                                    cols="12"
                                                                                    class="py-1 d-flex justify-space-between border-bottom"
                                                                                >
                                                                                    <span
                                                                                        class="text-uppercase black--text py-1 fw-700"
                                                                                        :class="
                                                                                            $breakpoint.smAndUp
                                                                                                ? 'f12'
                                                                                                : 'f10'
                                                                                        "
                                                                                    >
                                                                                        Bonus
                                                                                        Issued:
                                                                                    </span>
                                                                                    <span
                                                                                        class="text-right text-capitalize black--text py-1 fw-700"
                                                                                        :class="
                                                                                            $breakpoint.smAndUp
                                                                                                ? 'f12'
                                                                                                : 'f10'
                                                                                        "
                                                                                    >
                                                                                        {{
                                                                                            trnxData[0]
                                                                                                .date
                                                                                                ? $moment(
                                                                                                      trnxData[0]
                                                                                                          .date
                                                                                                  ).format(
                                                                                                      "Do-MMM-YY hh:mm a"
                                                                                                  )
                                                                                                : $moment(
                                                                                                      trnxData[0]
                                                                                                          .createdAt
                                                                                                  )
                                                                                                      .add(
                                                                                                          bonusExpireDate,
                                                                                                          "d"
                                                                                                      )
                                                                                                      .format(
                                                                                                          "Do-MMM-YY hh:mm a"
                                                                                                      )
                                                                                        }}
                                                                                    </span>
                                                                                </v-col>
                                                                                <v-col
                                                                                    cols="12"
                                                                                    class="py-1 d-flex justify-space-between"
                                                                                >
                                                                                    <span
                                                                                        class="text-uppercase black--text py-1 fw-700"
                                                                                        :class="
                                                                                            $breakpoint.smAndUp
                                                                                                ? 'f12'
                                                                                                : 'f10'
                                                                                        "
                                                                                    >
                                                                                        Bonus
                                                                                        Expiry:
                                                                                    </span>
                                                                                    <span
                                                                                        class="text-right text-capitalize black--text py-1 fw-700"
                                                                                        :class="
                                                                                            $breakpoint.smAndUp
                                                                                                ? 'f12'
                                                                                                : 'f10'
                                                                                        "
                                                                                    >
                                                                                        {{
                                                                                            trnxData[0]
                                                                                                .expiryDate
                                                                                                ? $moment(
                                                                                                      trnxData[0]
                                                                                                          .expiryDate
                                                                                                  ).format(
                                                                                                      "Do-MMM-YY hh:mm a"
                                                                                                  )
                                                                                                : $moment(
                                                                                                      trnxData[0]
                                                                                                          .createdAt
                                                                                                  )
                                                                                                      .add(
                                                                                                          bonusExpireDate,
                                                                                                          "d"
                                                                                                      )
                                                                                                      .format(
                                                                                                          "Do-MMM-YY hh:mm a"
                                                                                                      )
                                                                                        }}
                                                                                    </span>
                                                                                </v-col>
                                                                            </v-row>
                                                                        </v-expansion-panel-content>
                                                                        <v-expansion-panel-content
                                                                            v-else-if="
                                                                                !trnxData ||
                                                                                (trnxData &&
                                                                                    trnxData.length ==
                                                                                        0)
                                                                            "
                                                                            eager
                                                                        >
                                                                            <v-row
                                                                                no-gutters
                                                                                align="center"
                                                                                justify="center"
                                                                                class="text-center center"
                                                                            >
                                                                                <v-col
                                                                                    cols="12"
                                                                                    class="py-1"
                                                                                >
                                                                                    <span
                                                                                        class="text-capitalize black--text py-1 fw-700"
                                                                                        :class="
                                                                                            $breakpoint.smAndUp
                                                                                                ? 'f12'
                                                                                                : 'f10'
                                                                                        "
                                                                                    >
                                                                                        No
                                                                                        Bonus
                                                                                        Found
                                                                                    </span>
                                                                                </v-col>
                                                                            </v-row>
                                                                        </v-expansion-panel-content>
                                                                    </v-expansion-panel>
                                                                </v-expansion-panels>
                                                            </v-col>
                                                            <v-col
                                                                cols="12 py-3"
                                                            >
                                                                <div
                                                                    class="d-flex justify-end"
                                                                >
                                                                    <!-- <a
                                                                        href="/new-pending-bonus?type=Bonus"
                                                                        class="link transparent primary--text"
                                                                        >VIEW
                                                                        MORE
                                                                        <v-icon
                                                                            color="primary"
                                                                            class="right-arrow f14"
                                                                            >mdi-arrow-right</v-icon
                                                                        >
                                                                    </a> -->
                                                                    <v-btn
                                                                        :to="'/new-pending-bonus?type=Bonus'"
                                                                        color="primary"
                                                                        class="text-decoration link transparent"
                                                                        text
                                                                    >
                                                                        View
                                                                        More
                                                                        <v-icon
                                                                            color="primary"
                                                                            class="right-arrow f14"
                                                                            >mdi-arrow-right</v-icon
                                                                        >
                                                                    </v-btn>
                                                                </div>
                                                            </v-col>
                                                            <v-col
                                                                cols="12 py-3"
                                                            >
                                                                <div
                                                                    v-if="
                                                                        domainUrl
                                                                    "
                                                                >
                                                                    <a
                                                                        class="text-center text-uppercase blue--text py-3 fw-900"
                                                                        :class="
                                                                            $breakpoint.smAndUp
                                                                                ? 'f14'
                                                                                : 'f12'
                                                                        "
                                                                        @click="
                                                                            termspopup(
                                                                                'terms1'
                                                                            )
                                                                        "
                                                                        >Terms
                                                                        and
                                                                        Conditions</a
                                                                    >
                                                                </div>
                                                                <v-row
                                                                    justify="center"
                                                                >
                                                                    <v-dialog
                                                                        v-model="
                                                                            termsdialog1
                                                                        "
                                                                        scrollable
                                                                        width="400px"
                                                                        light
                                                                    >
                                                                        <v-card
                                                                            height="270px"
                                                                        >
                                                                            <v-card-title
                                                                                class="elevation-2"
                                                                            >
                                                                                <span
                                                                                    class="text-md-h5 text-sm-h5 dialog-title"
                                                                                >
                                                                                    Terms
                                                                                    and
                                                                                    Conditions
                                                                                </span>
                                                                            </v-card-title>
                                                                            <v-card-text
                                                                                v-if="
                                                                                    !termscheck
                                                                                "
                                                                            >
                                                                                <terms-conditions />
                                                                            </v-card-text>

                                                                            <v-card-actions>
                                                                                <v-spacer></v-spacer>
                                                                                <v-btn
                                                                                    color="primary"
                                                                                    class="dialog-btn"
                                                                                    @click="
                                                                                        termsdialog1 = false
                                                                                    "
                                                                                >
                                                                                    close
                                                                                </v-btn>
                                                                            </v-card-actions>
                                                                        </v-card>
                                                                    </v-dialog>
                                                                </v-row>
                                                            </v-col>
                                                        </v-row>
                                                    </div>
                                                </div>
                                            </v-card>
                                        </template>
                                    </dialog-card>
                                </v-dialog>
                            </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-switch
                                v-model="isBonusOn"
                                :loading="loading1"
                                :disabled="
                                    userBalanceData.bonus_balance >=
                                    minBonusAmount
                                        ? false
                                        : true
                                "
                                color="white"
                                flat
                                hide-details
                                @change="updateWallet('Bonus', isBonusOn)"
                            ></v-switch>
                        </v-list-item-action>
                    </template>
                </v-list-item>
            </v-list>
        </v-col>
        <v-list
            v-if="
                $auth.loggedIn &&
                userBalanceData &&
                userBalanceData.accessToken_bonus &&
                configurationData &&
                configurationData.isBonusWalletOn
            "
            dense
        >
            <v-list-item class="list_border">
                <v-list-item-subtitle class="white--text">
                    Bonus
                </v-list-item-subtitle>
                <v-list-item-title
                    class="font-weight-bold body-1 primary--text"
                >
                    {{ userBalanceData.bonus_balance | currencyFormat }}
                </v-list-item-title>
            </v-list-item>

            <v-list-item>
                <v-list-item-subtitle class="white--text">
                    Net Exposure
                </v-list-item-subtitle>
                <v-list-item-title
                    class="font-weight-bold body-1"
                    :class="domainUrl ? 'primary--text' : 'superNetExpo--text'"
                >
                    <div v-if="netExposureData.bonus_netExposure">
                        {{
                            (netExposureData.bonus_netExposure / getMyRate())
                                | currencyFormat
                        }}
                    </div>
                    <div v-if="!netExposureData.bonus_netExposure">
                        {{ 0 }}
                    </div>
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </div>
</template>
<script>
import { mapState } from "vuex"
import socket from "@/plugins/socket.client"
import socket1 from "@/plugins/newSocket.client.js"
import TermsConditions from "@/components/fairplay/bonusTerms&conditions"
import DialogCard from "@/components/fairplay/DialogCard.vue"
import encryptor from "~/plugins/encryption"
import constant from "~/constant"

export default {
    components: { DialogCard, TermsConditions },
    data() {
        return {
            domainUrl: process.env.THEME_BASIC === "true" ? 1 : 0,
            oldAccessToken: localStorage.getItem("accessToken"),
            accessToken: this.$auth.getToken("customLocal"),
            userId: this.$auth.user._id,
            userData: this.$auth.user.currencyType,
            bonusExpireDate: constant.bonusExpireDate || 21,
            isSportBonusOn: false,
            isBonusOn: false,
            isNormalWallet: true,
            loading: false,
            loading1: false,
            dialog1: false,
            dialog2: false,
            termscheck: false,
            termscheck2: false,
            termsdialog1: false,
            termsdialog2: false,
            minBonusAmount: 0,
            trnxData: [],
            isPanelOpen: false,
            isPanelOpen2: false,
            panelCheck1: 1,
            panelCheck2: 1,
            CancelBonusDialog: {},
            btnDisable: false,
            loadingYes: false
        }
    },
    computed: {
        ...mapState({
            userBalanceData: (state) => state.userBalance.userBalanceData,
            netExposureData: (state) => state.userBalance.netExposureData,
            newData: (state) => state.userBalance.newData,
            configurationData: (state) => state.user.configurationData
        }),
        userDetails() {
            return this.$store.state.profile.data
        },
        getUserCategory() {
            return this.$store.state.wallet.userCategory
        },
        user() {
            return this.$store.state.profile.data
        },
        limiter() {
            return this.$store.state.wallet.limiter
        },
        name() {
            return this.$store.state.profile.data.name
        },
        version() {
            return this.$store.state.profile.appversion
        },
        toDate() {
            return this.$store.state.transaction.toDate
        },
        fromDate() {
            return this.$store.state.transaction.fromDate
        },
        tripleTrnxData() {
            return this.$store.getters["transaction/tripleBonusTrnxData"]
        }
    },
    watch: {
        userBalanceData() {
            if (
                this.userBalanceData &&
                this.userBalanceData.sp_netExposure &&
                this.userBalanceData.sp_netExposure === 0
            ) {
                if (sessionStorage.getItem("sportsBonusComplete")) {
                    sessionStorage.removeItem("sportsBonusComplete")
                }
                this.completeTripleUserSportBonus()
            }
            if (
                this.userBalanceData &&
                this.userBalanceData.bonus_netExposure &&
                this.userBalanceData.bonus_netExposure === 0
            ) {
                if (sessionStorage.getItem("completeTripleUserBonus")) {
                    sessionStorage.removeItem("completeTripleUserBonus")
                }
                this.completeTripleUserBonus()
            }
            if (localStorage.getItem("accessTokenNewWallet")) {
                const abc = localStorage.getItem("accessTokenNewWallet")
                const jsonToken = JSON.parse(abc)
                if (jsonToken && jsonToken._id) {
                    // STEP1: Normal Sockets
                    socket.commonSocket.on(
                        "AllSocket_" + jsonToken._id,
                        (eventKeys) => {
                            this.insideSocketFunction(
                                eventKeys,
                                jsonToken._id,
                                jsonToken.accessToken
                            )
                        }
                    )
                    if (jsonToken && jsonToken.sbbonusid) {
                        // STEP2 : Sports Bonus Sockets
                        socket.commonSocket.on(
                            "AllSocket_" + jsonToken.sbbonusid,
                            (eventKeys) => {
                                this.insideSocketFunction(
                                    eventKeys,
                                    jsonToken.sbbonusid,
                                    jsonToken.accessToken_sp
                                )
                            }
                        )
                    }
                    if (jsonToken && jsonToken.bonusid) {
                        // STEP3 : Bonus Sockets
                        socket.commonSocket.on(
                            "AllSocket_" + jsonToken.bonusid,
                            (eventKeys) => {
                                this.insideSocketFunction(
                                    eventKeys,
                                    jsonToken.bonusid,
                                    jsonToken.accessToken_bonus
                                )
                            }
                        )
                    }
                }
            }
        }
    },

    async created() {
        this.$store.commit("transaction/vmodel_data", {
            vModel: "fromDate",
            value: this.$moment().subtract(29, "days").format("YYYY-MM-DD")
        })
        this.$store.commit("transaction/vmodel_data", {
            vModel: "toDate",
            value: this.$moment().format("YYYY-MM-DD")
        })
        try {
            if (this.$auth.loggedIn) {
                this.$store.dispatch("profile/getProfile")
                this.$store.dispatch("userBalance/getCurrentBalance")
                this.$store.dispatch("userBalance/getPendingBonusSum")

                this.$store.dispatch(
                    "socketMain/joinRoomsForUser",
                    socket.commonSocket.id
                )

                if (localStorage.getItem("accessTokenNewWallet")) {
                    const abc = localStorage.getItem("accessTokenNewWallet")
                    const jsonToken = JSON.parse(abc)
                    if (jsonToken && jsonToken._id) {
                        // STEP1: Normal Sockets
                        socket.commonSocket.on(
                            "AllSocket_" + jsonToken._id,
                            (eventKeys) => {
                                this.insideSocketFunction(
                                    eventKeys,
                                    jsonToken._id,
                                    jsonToken.accessToken
                                )
                            }
                        )
                        if (jsonToken && jsonToken.sbbonusid) {
                            // STEP2 : Sports Bonus Sockets
                            socket.commonSocket.on(
                                "AllSocket_" + jsonToken.sbbonusid,
                                (eventKeys) => {
                                    this.insideSocketFunction(
                                        eventKeys,
                                        jsonToken.sbbonusid,
                                        jsonToken.accessToken_sp
                                    )
                                }
                            )
                        }
                        if (jsonToken && jsonToken.bonusid) {
                            // STEP3 : Bonus Sockets
                            socket.commonSocket.on(
                                "AllSocket_" + jsonToken.bonusid,
                                (eventKeys) => {
                                    this.insideSocketFunction(
                                        eventKeys,
                                        jsonToken.bonusid,
                                        jsonToken.accessToken_bonus
                                    )
                                }
                            )
                        }
                    }
                }

                if (
                    localStorage &&
                    localStorage.getItem("getWithdrawalLimit") &&
                    localStorage.getItem("getWithdrawalLimit") !== null
                ) {
                    const limiterSet = JSON.parse(
                        encryptor.decrypt(
                            localStorage.getItem("getWithdrawalLimit")
                        )
                    )
                    this.$store.commit("wallet/set_limiter", limiterSet)
                } else {
                    await this.$store.dispatch("wallet/getWithdrawalLimit")
                    localStorage.setItem(
                        "getWithdrawalLimit",
                        encryptor.encrypt(JSON.stringify(this.limiter))
                    )
                }
                if (
                    process.client &&
                    localStorage.getItem("tripleWalletType")
                ) {
                    if (
                        localStorage.getItem("tripleWalletType") ===
                            "SportBonus" &&
                        this.configurationData &&
                        this.configurationData.isSportBonusWalletOn
                    ) {
                        this.isSportBonusOn = true
                        this.isBonusOn = false
                        this.isNormalWallet = false
                    } else if (
                        localStorage.getItem("tripleWalletType") === "Bonus" &&
                        this.configurationData &&
                        this.configurationData.isBonusWalletOn
                    ) {
                        this.isBonusOn = true
                        this.isSportBonusOn = false
                        this.isNormalWallet = false
                    } else {
                        localStorage.removeItem("tripleWalletType")
                        this.isSportBonusOn = false
                        this.isBonusOn = false
                        this.isNormalWallet = true
                    }
                } else {
                    this.isSportBonusOn = false
                    this.isBonusOn = false
                    this.isNormalWallet = true
                }
            }
        } catch (error) {}

        socket.commonSocket.on(
            "logout_" + this.accessToken + "_" + this.userId,
            (data) => {
                this.$store.dispatch("user/logout")
                this.$store.commit("snackbar/open", {
                    text: "Your session has ended, please login.",
                    color: "error"
                })
            }
        )
        this.$store.dispatch("fairplaySockets/joinRoomLogin", {
            accessToken: this.oldAccessToken,
            userId: this.userDetails._id,
            socket1Id: socket1.id
        })
        this.$store.dispatch("fairplaySockets/joinBonusRoom", {
            userId: this.userDetails._id,
            socket1Id: socket1.id
        })
        this.$store.dispatch("fairplaySockets/joinClearUserBonusRoom", {
            userId: this.userDetails._id,
            socket1Id: socket1.id
        })
        socket1.on(`clearuserdetails-${this.userDetails._id}`, (data) => {
            if (data) {
                if (data.cookieKey && this.$cookies.get(data.cookieKey)) {
                    this.$cookies.set(data.cookieKey, data.cookieKey, "0s")
                }
                if (
                    data.localStrKey &&
                    localStorage.getItem(data.localStrKey)
                ) {
                    localStorage.removeItem(data.localStrKey)
                }
            }
        })
        this.$store.dispatch("fairplaySockets/joinRoomForBlockUser", {
            socket1Id: socket1.id
        })
        const token1 = localStorage.getItem("accessToken")
        socket1.on(`blocked-${token1}`, (data) => {
            this.showSnackbar({
                content: data.message,
                color: "error"
            })
        })
        socket1.on(`userBonus-${this.userDetails._id}`, (data) => {
            this.$store.dispatch("profile/getProfileForBonusSocket")
        })
        this.$store.dispatch("fairplaySockets/joinRoomForWithdrawal", {
            socket1Id: socket1.id
        })
        socket1.on(
            "logout_" + this.oldAccessToken + "_" + this.userDetails._id,
            (data) => {
                this.$store.dispatch("user/logout")
                this.$store.commit("snackbar/open", {
                    text: "Your session has ended, please login.",
                    color: "error"
                })
            }
        )
    },
    beforeDestroy() {
        if (this.$auth.loggedIn) {
            socket.commonSocket.off("AllSocket_" + this.$auth.user._id)
        }

        socket.commonSocket.off(
            "logout_" + this.accessToken + "_" + this.userId
        )
        socket1.off(
            "logout_" + this.oldAccessToken + "_" + this.userDetails._id
        )
        this.$store.dispatch("fairplaySockets/leaveRoomLogin", {
            accessToken: this.oldAccessToken,
            userId: this.userDetails._id,
            socket1Id: socket1.id
        })
        socket1.off(`clearuserdetails-${this.userDetails._id}`)
        socket1.off(`sendNotificationToUser-${this.userId}`)
    },
    methods: {
        insideSocketFunction(eventKeys, userId, accessToken) {
            if (
                eventKeys.eventKey === "Balance_" + userId ||
                eventKeys.eventKey === "balanceWithData_" + userId ||
                eventKeys.eventKey === "winnerDeclared-fancy-" + userId
            ) {
                this.$store.dispatch("userBalance/getCurrentBalance")
                this.$store.dispatch("userBalance/getPendingBonusSum")
            } else if (
                eventKeys.eventKey ===
                "logout_" + accessToken + "_" + userId
            ) {
                this.$store.dispatch("user/logout")
                this.$store.commit("snackbar/open", {
                    text: "Your session has ended, please login.",
                    color: "error"
                })
            } else if (eventKeys.eventKey === "Rt_Invalidation_" + userId) {
                this.$store.commit("snackbar/open", {
                    text: eventKeys.message,
                    color: "error"
                })
            } else if (eventKeys.eventKey === "BetCancelled_" + userId) {
                this.$store.commit("snackbar/open", {
                    text: eventKeys.message,
                    color: "error"
                })
                this.$store.dispatch("openBets/getMyCurrentBetStatus", false)
            }
        },
        showSnackbar({ content, color }) {
            this.$store.commit("snackbar/open", {
                text: content,
                color
            })
        },
        async updateWallet(label, nSwitch) {
            if (process.client) {
                console.log("nSwitch", nSwitch, label)
                localStorage.removeItem("tripleWalletType")
                if (label && label === "SportBonus") {
                    if (nSwitch) {
                        localStorage.setItem("tripleWalletType", "SportBonus")
                    }
                    this.isBonusOn = false
                    this.isNormalWallet = false
                } else if (label && label === "Bonus") {
                    if (nSwitch) {
                        localStorage.setItem("tripleWalletType", "Bonus")
                    }
                    this.isSportBonusOn = false
                    this.isNormalWallet = false
                } else {
                    this.isBonusOn = false
                    this.isSportBonusOn = false
                    this.isNormalWallet = true
                }
                await this.$store.dispatch("user/getOneUiForTripleWallet")
                window.location.reload()
                // await this.$store.dispatch("userBalance/getCurrentBalance")
            }
        },
        termspopup(data) {
            if (data === "terms1") {
                this.termsdialog1 = true
                this.popuptitle = "Terms and Conditions"
            }
            if (data === "terms2") {
                this.termsdialog2 = true
                this.popuptitle = "Terms and Conditions"
            }
        },
        closeModal1() {
            this.dialog1 = false
            this.isPanelOpen = false
        },
        closeModal2() {
            this.dialog2 = false
            this.isPanelOpen2 = false
        },
        async isWageringInfo(typeWallet) {
            if (typeWallet === "SportBonus") {
                this.isPanelOpen = !this.isPanelOpen
            } else {
                this.isPanelOpen2 = !this.isPanelOpen2
            }
            this.trnxData = []
            if (this.isPanelOpen || this.isPanelOpen2) {
                await this.$store.dispatch(
                    "transaction/getAllBonusForTripleWallet",
                    {
                        status: "ongoing",
                        fromDate: this.fromDate,
                        toDate: this.toDate,
                        typeWallet
                    }
                )
            }

            if (this.tripleTrnxData && this.tripleTrnxData.length > 0) {
                this.trnxData = this.tripleTrnxData.map((obj) => {
                    if (
                        obj.transactionWay === "Bonus" &&
                        (obj.status === "pending" ||
                            obj.status === "ongoing") &&
                        obj.bonusProgress &&
                        obj.bonusProgress.data &&
                        obj.bonusProgress.data.milestoneAmount
                    ) {
                        obj.turnOverMinVal =
                            obj.bonusProgress.data.turnoverAmount
                        obj.turnOverMaxVal =
                            obj.bonusProgress.data.milestoneAmount
                        if (obj.turnOverMinVal <= obj.turnOverMaxVal) {
                            obj.turnOverInPercentage =
                                (obj.turnOverMinVal * 100) / obj.turnOverMaxVal
                        } else {
                            obj.turnOverInPercentage = 100
                        }
                        if (obj.turnOverInPercentage >= 100) {
                            if (typeWallet && typeWallet === "Bonus") {
                                this.completeTripleUserBonus()
                            } else {
                                this.completeTripleUserSportBonus()
                            }
                        }
                    } else {
                        obj.turnOverMinVal = 0
                        obj.turnOverMaxVal = 0
                        obj.turnOverInPercentage = 0
                    }
                    return obj
                })
            }
        },
        async completeTripleUserBonus() {
            if (
                !this.$cookies.isKey("completeTripleUserBonus") &&
                !sessionStorage.getItem("completeTripleUserBonus")
            ) {
                this.$cookies.set(
                    "completeTripleUserBonus",
                    "completeTripleUserBonus",
                    "5min"
                )
                const resData = await this.$store.dispatch(
                    "transaction/completeTripleUserBonus"
                )
                if (
                    resData &&
                    resData.data &&
                    resData.data.status === 200 &&
                    process.client
                ) {
                    await this.$store.dispatch(
                        "profile/getProfileForBonusSocket"
                    )
                    window.location.reload()
                } else if (
                    resData &&
                    resData.data &&
                    resData.data.status === 400 &&
                    process.client
                ) {
                    sessionStorage.setItem("completeTripleUserBonus", true)
                    this.showSnackbar({
                        content: resData.data.error,
                        color: "error"
                    })
                }
            }
        },
        async completeTripleUserSportBonus() {
            if (
                !this.$cookies.isKey("completeTripleUserSportsBonus") &&
                !sessionStorage.getItem("sportsBonusComplete")
            ) {
                this.$cookies.set(
                    "completeTripleUserSportsBonus",
                    "completeTripleUserSportsBonus",
                    "5min"
                )
                const resData = await this.$store.dispatch(
                    "transaction/completeTripleUserSportsBonus"
                )
                if (
                    resData &&
                    resData.data &&
                    resData.data.status === 200 &&
                    process.client
                ) {
                    await this.$store.dispatch(
                        "profile/getProfileForBonusSocket"
                    )
                    window.location.reload()
                } else if (
                    resData &&
                    resData.data &&
                    resData.data.status === 400 &&
                    process.client
                ) {
                    sessionStorage.setItem("sportsBonusComplete", true)

                    this.showSnackbar({
                        content: resData.data.error,
                        color: "error"
                    })
                }
            }
        },

        openDialog() {
            this.dialog2 = false
            this.dialog1 = true
            this.panelCheck1 = 1
            this.trnxData = []
        },
        openDialog2() {
            this.dialog1 = false
            this.dialog2 = true
            this.panelCheck2 = 1
            this.trnxData = []
        },
        errorbasedActivity(id) {
            this.dialog1 = false
            this.dialog2 = false
            this.panelCheck1 = false
            this.panelCheck2 = false
            this.loadingYes = false
            this.$set(this.CancelBonusDialog, id, false)
            this.isPanelOpen = false
            this.isPanelOpen2 = false
        },
        async changeStatusBonusInstance(id, walletType) {
            this.loadingYes = true
            if (
                walletType &&
                walletType === "Bonus" &&
                this.userBalanceData &&
                this.userBalanceData.bonus_netExposure !== 0
            ) {
                this.errorbasedActivity(id)
                this.showSnackbar({
                    content:
                        "Dear user your current bet is in progress kindly wait for result and try again!",
                    color: "error"
                })
                return
            } else if (
                walletType &&
                walletType === "SportBonus" &&
                this.userBalanceData &&
                this.userBalanceData.sp_netExposure !== 0
            ) {
                this.errorbasedActivity(id)
                this.showSnackbar({
                    content:
                        "Dear user your current bet is in progress kindly wait for result and try again!",
                    color: "error"
                })
                return
            }
            // const jsonData = {
            //   transactionId: this.cancelBonusData._id
            // }
            const resData = await this.$store.dispatch(
                "transaction/changeBonusTrnxStatus",
                { id }
            )
            this.loadingYes = false
            this.$set(this.CancelBonusDialog, id, false)
            // this.CancelBonusDialog = false
            if (!resData) {
                this.showSnackbar({
                    content: "Please Try Again !!!",
                    color: "error"
                })
            } else if (resData && resData.status) {
                if (resData.status === 200 && resData.data) {
                    this.showSnackbar({
                        content: resData.data.message
                            ? resData.data.message
                            : `Transaction Status Changed`,
                        color: "success"
                    })
                    this.isPanelOpen = false
                    this.isPanelOpen2 = false
                    this.isWageringInfo(walletType)
                    await this.$store.dispatch("userBalance/getCurrentBalance")
                } else if (resData.status === 401) {
                    this.errorbasedActivity(id)
                    this.showSnackbar({
                        content: "Session Expired Please Login Again",
                        color: "error"
                    })
                    this.$store.commit("authenticate/set_error", null)
                    this.$store.dispatch("user/logout")
                } else if (resData.data && resData.data.error) {
                    this.errorbasedActivity(id)
                    if (typeof resData.data.error === "string") {
                        this.showSnackbar({
                            content:
                                resData.data.error ||
                                "Transaction Status Not Changed",
                            color: "error"
                        })
                    } else {
                        for (const x in resData.data.error) {
                            this.showSnackbar({
                                content:
                                    resData.data.error[x] ||
                                    "Transaction Status Not Changed",
                                color: "error"
                            })
                        }
                    }
                } else {
                    this.errorbasedActivity(id)
                    this.showSnackbar({
                        content: `Transaction Status Not Changed`,
                        color: "error"
                    })
                }
            } else {
                this.showSnackbar({
                    content: "Please Try Again !!!",
                    color: "error"
                })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.drawer-user-balance {
    .v-list-item__subtitle {
        flex: 1 1 100%;
        overflow: hidden;
        text-overflow: unset !important;
        white-space: unset !important;
    }
}
.view-benefits-btn {
    color: $white !important;
    text-decoration: none;
}
.view-benefits-btn .v-icon {
    margin-left: -4px;
    color: $white !important;
}
.view-benefits-btn:hover,
.view-benefits-btn:hover .v-icon {
    color: $black !important;
}
.green_bg {
    background: var(--v-bottomChildColor-base);
}
.list_border {
    border-bottom: 1px solid grey;
}
.white_bg {
    background: $white !important;
}
.card-padd {
    .v-card__text {
        padding: 0px !important;
    }
}
.border-bottom {
    border-bottom: 0.5px solid gray;
}
.ma-top {
    margin-top: -14px;
}
.bonus-content {
    margin-top: 22px;
}
@media only screen and (max-width: 280px) {
    .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
        padding: 0px 12px 16px !important;
    }
    .font-8 {
        font-size: 8px !important;
    }
}
</style>
